import { Tables } from "@/lib/supabase/supabase_types_override";
import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/lib/useQuery/queryKeys";

export function useGetSurveyById(surveyId?: Tables<'survey'>['id']) {
    return useQuery({
        ...queryKeys.survey.details(surveyId!),
        enabled: !!surveyId,
    });
}
